module.exports = ".row {\n  margin-right: unset;\n  margin-left: unset;\n}\n\n.required {\n  color: red;\n  display: block;\n  margin-bottom: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/price-control/price-control.component.css
// module id = ./src/app/price-control/price-control.component.css
// module chunks = main